import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied-page',
  templateUrl: './access-denied-page.component.html',
  styleUrls: ['../page-not-found/page-not-found.component.scss'],
})
export class AccessDeniedPageComponent {
  constructor(private router: Router) {}

  goHome() {
    this.router.navigate(['/settings/clients']);
  }
}
